import React from "react"
import CtaButtons from "../home/CtaButtons.jsx"

// Shared inner-page hero using the brand gradient (.brand-hero in index.css).
// The light-blue band at the top holds the optional eyebrow pill (navy on
// white, so it reads on any part of the gradient). The band has a fixed
// height so the heading always starts at the #457b9d stop, where white text
// meets WCAG AA, whether or not a page has an eyebrow.
export default function PageHero({ eyebrow, title, lead, showCtas = true, service, children }) {
  return (
    <section className="brand-hero relative overflow-hidden text-white">
      <div className="relative mx-auto max-w-6xl px-4 pb-16 pt-28 sm:px-6 sm:pb-20">
        <div className="flex h-8 items-center">
          {eyebrow && <p className="brand-hero-pill">{eyebrow}</p>}
        </div>
        <h1 className="mt-14 max-w-4xl text-4xl font-bold leading-[1.1] tracking-tight sm:text-5xl">
          {title}
        </h1>
        {lead && (
          <p className="mt-6 max-w-2xl text-lg leading-relaxed text-blue-50 sm:text-xl">{lead}</p>
        )}
        {showCtas && <CtaButtons tone="light" className="mt-9" service={service} />}
        {children}
      </div>
    </section>
  )
}
